import React from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from 'react-icons/io';

const DeleteModal = ({ showModal, setShowModal, onConfirm }) => {
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={closeModal}
      contentLabel="Delete Confirmation"
      style={{
        content: {
          width: '23%',
          height: '23%',
          margin: 'auto',
          borderRadius: '20px',
          padding: 0,
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      }}
    >
      <div className="flex justify-between mx-5 my-3">
        <h3 className="font-medium">Confirm Delete</h3>
        <button onClick={closeModal}>
          <IoMdCloseCircleOutline size={20} />
        </button>
      </div>
      <hr />
      <div className="flex justify-center mx-5 my-3">
        <h2>Are you sure you want to delete?</h2>
      </div>
      <div className="flex justify-end mx-5 my-3 gap-3">
        <button
          onClick={closeModal}
          className="border border-red-500 bg-red-500 text-white p-1 px-5 rounded-lg"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            onConfirm();
            closeModal();
          }}
          className="border border-red-500 bg-red-700 text-white p-1 px-5 rounded-lg"
        >
          Delete
        </button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
